import { backendClient } from "../../api/backend";
import * as types from "./types";

const setLoading = (loading) => ({ type: types.MARKETING_SET_LOADING, payload: loading });
const setError = (error) => ({ type: types.MARKETING_SET_ERROR, payload: error });

// Dashboard
export const fetchMarketingDashboard = () => async (dispatch) => {
  dispatch(setLoading(true));
  try {
    const data = await backendClient.getMarketingDashboard();
    dispatch({ type: types.MARKETING_SET_DASHBOARD, payload: data });
  } catch (e) {
    dispatch(setError(e.message));
  } finally {
    dispatch(setLoading(false));
  }
};

// Campaigns
export const fetchMarketingCampaigns = (params) => async (dispatch) => {
  dispatch(setLoading(true));
  try {
    const data = await backendClient.getMarketingCampaigns(params);
    dispatch({ type: types.MARKETING_SET_CAMPAIGNS, payload: data });
  } catch (e) {
    dispatch(setError(e.message));
  } finally {
    dispatch(setLoading(false));
  }
};

export const fetchMarketingCampaign = (id) => async (dispatch) => {
  try {
    const data = await backendClient.getMarketingCampaign(id);
    dispatch({ type: types.MARKETING_SET_CURRENT_CAMPAIGN, payload: data });
    return data;
  } catch (e) {
    dispatch(setError(e.message));
  }
};

export const createMarketingCampaign = (data) => async (dispatch) => {
  const result = await backendClient.createMarketingCampaign(data);
  dispatch(fetchMarketingCampaigns());
  return result;
};

export const updateMarketingCampaign = (id, data) => async (dispatch) => {
  const result = await backendClient.updateMarketingCampaign(id, data);
  dispatch({ type: types.MARKETING_SET_CURRENT_CAMPAIGN, payload: result });
  return result;
};

export const deleteMarketingCampaign = (id) => async (dispatch) => {
  await backendClient.deleteMarketingCampaign(id);
  dispatch(fetchMarketingCampaigns());
};

export const scheduleMarketingCampaign = (id, scheduledAt) => async (dispatch) => {
  const result = await backendClient.scheduleMarketingCampaign(id, scheduledAt);
  dispatch({ type: types.MARKETING_SET_CURRENT_CAMPAIGN, payload: result });
  return result;
};

export const sendMarketingCampaignNow = (id) => async (dispatch) => {
  const result = await backendClient.sendMarketingCampaignNow(id);
  dispatch({ type: types.MARKETING_SET_CURRENT_CAMPAIGN, payload: result });
  return result;
};

export const pauseMarketingCampaign = (id) => async (dispatch) => {
  const result = await backendClient.pauseMarketingCampaign(id);
  dispatch({ type: types.MARKETING_SET_CURRENT_CAMPAIGN, payload: result });
  return result;
};

export const resumeMarketingCampaign = (id) => async (dispatch) => {
  const result = await backendClient.resumeMarketingCampaign(id);
  dispatch({ type: types.MARKETING_SET_CURRENT_CAMPAIGN, payload: result });
  return result;
};

// Campaign Analytics
export const fetchCampaignStats = (id) => async (dispatch) => {
  const data = await backendClient.getMarketingCampaignStats(id);
  dispatch({ type: types.MARKETING_SET_CAMPAIGN_STATS, payload: data });
  return data;
};

export const fetchCampaignFunnel = (id) => async (dispatch) => {
  const data = await backendClient.getMarketingCampaignFunnel(id);
  dispatch({ type: types.MARKETING_SET_CAMPAIGN_FUNNEL, payload: data });
  return data;
};

export const fetchCampaignSends = (id, params) => async (dispatch) => {
  const data = await backendClient.getMarketingCampaignSends(id, params);
  dispatch({ type: types.MARKETING_SET_CAMPAIGN_SENDS, payload: data });
  return data;
};

export const fetchCampaignABResults = (id) => async () => {
  return await backendClient.getMarketingCampaignABResults(id);
};

// Sequences
export const fetchAllMarketingSequences = (params) => async (dispatch) => {
  const data = await backendClient.getAllMarketingSequences(params);
  dispatch({ type: types.MARKETING_SET_ALL_SEQUENCES, payload: data });
  return data;
};

export const fetchMarketingSequence = (id) => async () => {
  return await backendClient.getMarketingSequence(id);
};

export const fetchMarketingSequences = (campaignId) => async (dispatch) => {
  const data = await backendClient.getMarketingSequences(campaignId);
  dispatch({ type: types.MARKETING_SET_SEQUENCES, payload: data });
  return data;
};

export const createMarketingSequence = (campaignId, data) => async (dispatch) => {
  const result = await backendClient.createMarketingSequence(campaignId, data);
  dispatch(fetchMarketingSequences(campaignId));
  return result;
};

export const updateMarketingSequence = (id, data) => async () => {
  return await backendClient.updateMarketingSequence(id, data);
};

export const createMarketingSequenceStep = (sequenceId, data) => async () => {
  return await backendClient.createMarketingSequenceStep(sequenceId, data);
};

export const updateMarketingSequenceStep = (sequenceId, stepId, data) => async () => {
  return await backendClient.updateMarketingSequenceStep(sequenceId, stepId, data);
};

export const deleteMarketingSequenceStep = (sequenceId, stepId) => async () => {
  return await backendClient.deleteMarketingSequenceStep(sequenceId, stepId);
};

// Templates
export const fetchMarketingTemplates = (params) => async (dispatch) => {
  const data = await backendClient.getMarketingTemplates(params);
  dispatch({ type: types.MARKETING_SET_TEMPLATES, payload: data });
  return data;
};

export const fetchMarketingTemplate = (id) => async (dispatch) => {
  const data = await backendClient.getMarketingTemplate(id);
  dispatch({ type: types.MARKETING_SET_CURRENT_TEMPLATE, payload: data });
  return data;
};

export const createMarketingTemplate = (data) => async (dispatch) => {
  const result = await backendClient.createMarketingTemplate(data);
  dispatch(fetchMarketingTemplates());
  return result;
};

export const updateMarketingTemplate = (id, data) => async (dispatch) => {
  const result = await backendClient.updateMarketingTemplate(id, data);
  dispatch({ type: types.MARKETING_SET_CURRENT_TEMPLATE, payload: result });
  return result;
};

export const deleteMarketingTemplate = (id) => async (dispatch) => {
  await backendClient.deleteMarketingTemplate(id);
  dispatch(fetchMarketingTemplates());
};

export const duplicateMarketingTemplate = (id) => async (dispatch) => {
  const result = await backendClient.duplicateMarketingTemplate(id);
  dispatch(fetchMarketingTemplates());
  return result;
};

// Contacts
export const fetchMarketingContacts = (params) => async (dispatch) => {
  dispatch(setLoading(true));
  try {
    const data = await backendClient.getMarketingContacts(params);
    dispatch({ type: types.MARKETING_SET_CONTACTS, payload: data });
  } catch (e) {
    dispatch(setError(e.message));
  } finally {
    dispatch(setLoading(false));
  }
};

export const fetchMarketingContact = (id) => async (dispatch) => {
  const data = await backendClient.getMarketingContact(id);
  dispatch({ type: types.MARKETING_SET_CURRENT_CONTACT, payload: data });
  return data;
};

export const createMarketingContact = (data) => async (dispatch) => {
  const result = await backendClient.createMarketingContact(data);
  dispatch(fetchMarketingContacts());
  return result;
};

export const updateMarketingContact = (id, data) => async (dispatch) => {
  const result = await backendClient.updateMarketingContact(id, data);
  dispatch({ type: types.MARKETING_SET_CURRENT_CONTACT, payload: result });
  dispatch({ type: types.MARKETING_UPDATE_CONTACT_IN_LIST, payload: result });
  return result;
};

export const deleteMarketingContact = (id) => async (dispatch) => {
  await backendClient.deleteMarketingContact(id);
  dispatch(fetchMarketingContacts());
};

export const fetchContactTimeline = (id, params) => async (dispatch) => {
  const data = await backendClient.getMarketingContactTimeline(id, params);
  dispatch({ type: types.MARKETING_SET_TIMELINE, payload: data });
  return data;
};

export const importMarketingContacts = (file, segmentId) => async (dispatch) => {
  const result = await backendClient.importMarketingContacts(file, segmentId);
  dispatch(fetchMarketingContacts());
  return result;
};

export const fetchMarketingImports = (params) => async (dispatch) => {
  const data = await backendClient.getMarketingImports(params);
  dispatch({ type: types.MARKETING_SET_IMPORTS, payload: data });
  return data;
};

// Segments
export const fetchMarketingSegments = () => async (dispatch) => {
  const data = await backendClient.getMarketingSegments();
  dispatch({ type: types.MARKETING_SET_SEGMENTS, payload: data });
  return data;
};

export const createMarketingSegment = (data) => async (dispatch) => {
  const result = await backendClient.createMarketingSegment(data);
  dispatch(fetchMarketingSegments());
  return result;
};

export const updateMarketingSegment = (id, data) => async (dispatch) => {
  const result = await backendClient.updateMarketingSegment(id, data);
  dispatch(fetchMarketingSegments());
  return result;
};

export const deleteMarketingSegment = (id) => async (dispatch) => {
  await backendClient.deleteMarketingSegment(id);
  dispatch(fetchMarketingSegments());
};

// Automations
export const fetchMarketingAutomations = (params) => async (dispatch) => {
  const data = await backendClient.getMarketingAutomations(params);
  dispatch({ type: types.MARKETING_SET_AUTOMATIONS, payload: data });
  return data;
};

export const createMarketingAutomation = (data) => async (dispatch) => {
  const result = await backendClient.createMarketingAutomation(data);
  dispatch(fetchMarketingAutomations());
  return result;
};

export const updateMarketingAutomation = (id, data) => async (dispatch) => {
  await backendClient.updateMarketingAutomation(id, data);
  dispatch(fetchMarketingAutomations());
};

export const deleteMarketingAutomation = (id) => async (dispatch) => {
  await backendClient.deleteMarketingAutomation(id);
  dispatch(fetchMarketingAutomations());
};

export const activateMarketingAutomation = (id) => async (dispatch) => {
  await backendClient.activateMarketingAutomation(id);
  dispatch(fetchMarketingAutomations());
};

export const pauseMarketingAutomation = (id) => async (dispatch) => {
  await backendClient.pauseMarketingAutomation(id);
  dispatch(fetchMarketingAutomations());
};

// Scoring
export const fetchMarketingScoringRules = () => async (dispatch) => {
  const data = await backendClient.getMarketingScoringRules();
  dispatch({ type: types.MARKETING_SET_SCORING_RULES, payload: data });
  return data;
};

export const createMarketingScoringRule = (data) => async (dispatch) => {
  await backendClient.createMarketingScoringRule(data);
  dispatch(fetchMarketingScoringRules());
};

export const deleteMarketingScoringRule = (id) => async (dispatch) => {
  await backendClient.deleteMarketingScoringRule(id);
  dispatch(fetchMarketingScoringRules());
};

export const recalculateMarketingScores = () => async () => {
  return await backendClient.recalculateMarketingScores();
};

// Organizations
export const fetchMarketingOrganizations = (params = {}) => async (dispatch) => {
  try {
    const data = await backendClient.getMarketingOrganizations(params);
    dispatch({ type: types.MARKETING_SET_ORGANIZATIONS, payload: data });
    return data;
  } catch (e) {
    dispatch(setError(e.message));
  }
};

export const fetchMarketingOrganization = (id) => async (dispatch) => {
  try {
    const data = await backendClient.getMarketingOrganization(id);
    dispatch({ type: types.MARKETING_SET_CURRENT_ORGANIZATION, payload: data });
    return data;
  } catch (e) {
    dispatch(setError(e.message));
  }
};

export const createMarketingOrganization = (data) => async (dispatch) => {
  const result = await backendClient.createMarketingOrganization(data);
  dispatch(fetchMarketingOrganizations());
  return result;
};

export const updateMarketingOrganization = (id, data) => async (dispatch) => {
  const result = await backendClient.updateMarketingOrganization(id, data);
  dispatch({ type: types.MARKETING_SET_CURRENT_ORGANIZATION, payload: result });
  dispatch(fetchMarketingOrganizations());
  return result;
};

export const deleteMarketingOrganization = (id) => async (dispatch) => {
  await backendClient.deleteMarketingOrganization(id);
  dispatch(fetchMarketingOrganizations());
};

export const linkContactToMarketingOrg = (orgId, contactId) => async (dispatch) => {
  await backendClient.linkContactToMarketingOrg(orgId, contactId);
  dispatch(fetchMarketingOrganization(orgId));
};

export const unlinkContactFromMarketingOrg = (orgId, contactId) => async (dispatch) => {
  await backendClient.unlinkContactFromMarketingOrg(orgId, contactId);
  dispatch(fetchMarketingOrganization(orgId));
};

// Org Tasks
export const fetchOrgTasks = (orgId) => async (dispatch) => {
  const data = await backendClient.getOrgTasks(orgId);
  dispatch({ type: types.MARKETING_SET_ORG_TASKS, payload: data });
  return data;
};

export const createOrgTask = (orgId, data) => async (dispatch) => {
  const result = await backendClient.createOrgTask(orgId, data);
  dispatch(fetchOrgTasks(orgId));
  return result;
};

export const updateOrgTask = (orgId, taskId, data) => async (dispatch) => {
  const result = await backendClient.updateOrgTask(orgId, taskId, data);
  dispatch(fetchOrgTasks(orgId));
  return result;
};

export const deleteOrgTask = (orgId, taskId) => async (dispatch) => {
  await backendClient.deleteOrgTask(orgId, taskId);
  dispatch(fetchOrgTasks(orgId));
};

// Org Activity
export const fetchOrgActivity = (orgId, page = 1) => async (dispatch) => {
  const data = await backendClient.getOrgActivity(orgId, { page });
  dispatch({ type: types.MARKETING_SET_ORG_ACTIVITY, payload: data });
  return data;
};

// Org Email
export const sendOrgEmail = (orgId, formData) => async () => {
  return await backendClient.sendOrgEmail(orgId, formData);
};

// Pipeline
export const fetchPipeline = (params) => async (dispatch) => {
  dispatch(setLoading(true));
  try {
    const data = await backendClient.getPipeline(params);
    dispatch({ type: types.MARKETING_SET_PIPELINE, payload: data });
  } catch (e) {
    dispatch(setError(e.message));
  } finally {
    dispatch(setLoading(false));
  }
};

// Upcoming Tasks (Dashboard)
export const fetchUpcomingTasks = () => async (dispatch) => {
  const data = await backendClient.getUpcomingTasks();
  dispatch({ type: types.MARKETING_SET_UPCOMING_TASKS, payload: data });
  return data;
};

// WhatsApp
export const fetchMarketingWhatsAppLogs = (params) => async (dispatch) => {
  const data = await backendClient.getMarketingWhatsAppLogs(params);
  dispatch({ type: types.MARKETING_SET_WHATSAPP_LOGS, payload: data });
  return data;
};

export const createMarketingWhatsAppLog = (data) => async (dispatch) => {
  await backendClient.createMarketingWhatsAppLog(data);
  dispatch(fetchMarketingWhatsAppLogs());
};

export const updateMarketingWhatsAppLog = (id, data) => async (dispatch) => {
  await backendClient.updateMarketingWhatsAppLog(id, data);
  dispatch(fetchMarketingWhatsAppLogs());
};

export const deleteMarketingWhatsAppLog = (id) => async (dispatch) => {
  await backendClient.deleteMarketingWhatsAppLog(id);
  dispatch(fetchMarketingWhatsAppLogs());
};
